import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "progress-info" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "progress-center" }
const _hoisted_4 = ["src"]

import leftIcon from "@/assets/left_icon.png";
import rightIcon from "@/assets/right_icon.png";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressItem',
  props: {
  totalVersion: Array,
  currentVersion: Object,
  currentVersionIndex: Number,
},
  emits: ["decreaseVersion", "increaseVersion"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const props = __props;

const format = () =>
  `${props.currentVersionIndex}/${props.totalVersion?.length}`;

//上一版
const increase = () => {
  emits("increaseVersion");
};
//下一版
const decrease = () => {
  emits("decreaseVersion");
};

return (_ctx: any,_cache: any) => {
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "progress-left",
      onClick: increase
    }, [
      _createElementVNode("img", { src: _unref(leftIcon) }, null, 8, _hoisted_2),
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "上一版", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_progress, {
        percentage: (__props.currentVersionIndex / __props.totalVersion.length) * 100,
        color: "#0D59FA",
        "stroke-width": "8",
        format: format
      }, null, 8, ["percentage"])
    ]),
    _createElementVNode("div", {
      class: "progress-right",
      onClick: decrease
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "下一版", -1)),
      _createElementVNode("img", { src: _unref(rightIcon) }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})